export const ActionTypes = {
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    INCREASE_QUANTITY: "INCREASE_QUANTITY",
    DECREASE_QUANTITY: "DECREASE_QUANTITY",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    ADD_TO_CART_FROM_PRODUCT: "ADD_TO_CART_FROM_PRODUCT",
    ADD_TO_FAVORITE: "ADD_TO_FAVORITE",
    REMOVE_FROM_FAVORITE: "REMOVE_FROM_FAVORITE",
    SET_GRID_VIEW: "SET_GRID_VIEW",
    SET_LIST_VIEW: "SET_LIST_VIEW",
    FILTER_PRODUCTS: "FILTER_PRODUCTS",
    FILTER_PRODUCTS_ALL: "FILTER_PRODUCTS_ALL",
    SORT_METHOD: "SORT_METHOD",
    SORT_PRODUCTS: "SORT_PRODUCTS",
    IS_LIKED: "IS_LIKED",
    SET_USER: "SET_USER",
    LOGOUT: "LOGOUT",
}